import React from 'react';

import styled from '@mint-lib/styled';

export interface Props {
  children: React.ReactNode;
}

const BreadcrumbSeparator = ({ children }: Props) => (
  <StyledSeparator>{children}</StyledSeparator>
);

const StyledSeparator = styled('div')(({ theme }) => ({
  margin: 'auto 8px',
  color: theme.palette.text.primary,
  userSelect: 'none',
}));
export default BreadcrumbSeparator;
